import script from "./BeatLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./BeatLoader.vue?vue&type=script&setup=true&lang=js"

import "./BeatLoader.vue?vue&type=style&index=0&id=611b6237&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-611b6237"]])

export default __exports__